/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { defineMessages, FormattedMessage } from "react-intl";
import { CHILDREN_COUNT_FIELD } from "./constants";
import styles from "./BookingForm.scss";
import OccupantTypeSelector from "./OccupantTypeSelector";
import range from "lodash/range";

const msgs = defineMessages({
  confirm: {
    id: "booking_form.ageSelector.button.confirm",
    description: "Confirm Button",
    defaultMessage: "Confirm",
  },
  agesText: {
    id: "booking_form.ageSelector.childrenAges.description",
    description: "explanatory text for children ages selector",
    defaultMessage: "Ages of children at check-out",
  },
});

class AgeSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      childrenCount: props.initialChildrenCount,
      guestAges: props.initialGuestAges,
    };
    this.changeChildrenCount = this.changeChildrenCount.bind(this);
    this.changeChildrenAge = this.changeChildrenAge.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  changeChildrenCount(value) {
    const { guestAges } = this.state;
    this.setState({
      childrenCount: parseInt(value),
      guestAges: range(0, parseInt(value), 1).map(value => (guestAges && guestAges[value]) || 0),
    });
    //this.props.fields[CHILDREN_COUNT_FIELD].onChange(value);

    if (this.props.onChange) {
      this.props.onChange({
        childrenCount: parseInt(value),
        guestAges: range(0, parseInt(value), 1).map(value => (guestAges && guestAges[value]) || 0),
      });
    }
  }

  changeChildrenAge(value, idx) {
    const { guestAges } = this.state;
    guestAges[idx] = value;
    this.setState({
      guestAges,
    });

    if (this.props.onChange) {
      this.props.onChange({
        childrenCount: this.state.childrenCount,
        guestAges,
      });
    }
  }

  handleSubmit() {
    this.props.onSubmit({
      childrenCount: this.state.childrenCount,
      guestAges: this.state.guestAges && this.state.guestAges.map(it => parseInt(it)),
    });
    this.props.handleCloseModal();
  }

  render() {
    const {
      fields,
      selectorsRange,
      childrenAgeRange,
      onSubmit,
      fullWidth,
      enabledSelectors,
      ageRanges,
    } = this.props;
    const { guestAges, childrenCount } = this.state;
    return (
      <div className={classnames("AgeSelector", styles.container, styles.ageSelectorContainer)}>
        <div className={styles.peopleContainer}>
          <div
            className={classnames(
              "wbkv9-OccupantsList-OccupantTypeContainerList",
              styles.occupantTypeContainerList
            )}>
            {enabledSelectors.map((type, idx) => {
              const minAge =
                enabledSelectors.length > 1 &&
                ageRanges &&
                (ageRanges[type].min !== null || ageRanges[type].min === 0)
                  ? ageRanges[type].min
                  : null;
              const maxAge =
                enabledSelectors.length > 1 &&
                ageRanges &&
                (ageRanges[type].max !== null || ageRanges[type].max === 0)
                  ? ageRanges[type].max
                  : null;

              return (
                <div
                  key={idx}
                  className={classnames(
                    "wbkv9-OccupantsList-OccupantTypeContainer",
                    styles.occupantTypeContainer
                  )}>
                  <OccupantTypeSelector
                    key={type}
                    field={fields[type]}
                    occupantRange={selectorsRange[type]}
                    minAge={minAge}
                    maxAge={maxAge}
                    fullWidth={fullWidth}
                  />
                </div>
              );
            })}
          </div>
          <div className={styles.selectorsContainer}>
            {fields[CHILDREN_COUNT_FIELD] && (
              <OccupantTypeSelector
                onChange={event => {
                  this.changeChildrenCount(event.target.value);
                }}
                field={fields[CHILDREN_COUNT_FIELD]}
                value={childrenCount}
                occupantRange={
                  selectorsRange[CHILDREN_COUNT_FIELD] && selectorsRange[CHILDREN_COUNT_FIELD].range
                }
                minAge={childrenAgeRange.min}
                maxAge={childrenAgeRange.max}
                fullWidth={fullWidth}
              />
            )}
          </div>
        </div>
        {childrenCount > 0 && (
          <div className={classnames("wbkv9-AgeSelector-agesContainer", styles.agesContainer)}>
            <div className={classnames("wbkv9-AgeSelector-textAgesContainer", styles.agesText)}>
              <FormattedMessage {...msgs.agesText} />
            </div>

            <div className={classnames("wbkv9-AgeSelector-ageSelectorsContainer", styles.fullRow)}>
              <div className={styles.ageSelectorsContainer}>
                {guestAges.map((value, idx) => (
                  <OccupantTypeSelector
                    hideIcon
                    onChange={event => {
                      this.changeChildrenAge(event.target.value, idx);
                    }}
                    value={value}
                    key={"age" + idx}
                    field={{
                      name: "age" + idx,
                    }}
                    occupantRange={selectorsRange.childrenAges && selectorsRange.childrenAges.range}
                    minAge={childrenAgeRange.min}
                    maxAge={childrenAgeRange.max}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
        {onSubmit && (
          <div className={classnames("buttonContainer")} onClick={this.handleSubmit}>
            <button type="submit">
              <div className="text">
                <FormattedMessage {...msgs.confirm} />
              </div>
            </button>
          </div>
        )}
      </div>
    );
  }
}

AgeSelector.propTypes = {
  fields: PropTypes.object.isRequired,
};

export default AgeSelector;
